import React from 'react';
import ProductCard from './ProductCard';

function CategoriaPage({ categoria, productos, onAgregar }) {
  const productosFiltrados = productos.filter(p => p.nombreCategoria.toLowerCase() === categoria.toLowerCase());

  return (
    <section className="product-section">
      <h2>{categoria.toUpperCase()}</h2>
      <div className="product-grid">
        {productosFiltrados.map(product => (
          <ProductCard
            key={product.id}
            idProduct={product.id}
            name={product.nombre}
            description={product.descripcion}
            price={product.precio}
            image={product.imagen ? product.imagen.replace(/\\/g, "/") : null}
            especificacion={product.especificacion}
            onAgregar={onAgregar}
          />
        ))}
      </div>
    </section>
  );
}

export default CategoriaPage;